import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'acFunc'})
export class AcFuncPipe implements PipeTransform {
    static urlToId = (url) => url.toLowerCase().split('/').filter((u) => !!u).join('-');

    transform<T = any>(value: any, func: (...args: any[]) => T, ...args): T {
        return func(value, ...args);
    }
}
